import app from "flarum/forum/app";
import { extend, override } from "flarum/extend";
import Application from "flarum/common/Application";
import Discussion from "flarum/common/models/Discussion";
import Extend from "flarum/common/extenders";
import Button from 'flarum/common/components/Button';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import ReplyControlModal from "./components/ReplyControlModal";

const extended = [new Extend.Model(Discussion).attribute("replyMode")];

export { extended as extend };

app.initializers.add("lltq-reply-control", (app) => {
  extend(DiscussionControls, 'userControls', function (items) {
    if (app.current.get('discussion')?.replyMode() !== undefined) {
      items.add('reply-control', Button.component({
          className: 'Button--filter-toolbar',
          onclick() {
            const discussion = app.current.get('discussion');
            app.modal.show(ReplyControlModal, {
              discussion: discussion
            });
          },
          icon: 'fas fa-list',
      }, app.translator.trans('lltq-reply-control.forum.reply_control')));
    }
  });  
});
